import { IHowItWorksPageProps } from "./HowItWorksPage.types";
import { useMicrositeProductPage } from "@ubnt/store.core/lib/components/Microsites/context/MicrositeProductPageContext";
import * as S from "./HowItWorksPage.styles";
import React from "react";
import { StyledContainer } from "components/StyledContainer";
import { MicrositeHeading } from "pages/LayoutComponents/MicrositeHeading";
import { useTranslation } from "hooks/useTranslation";
import { Topology } from "pages/Sections/GettingStartedWithUniFi/_components/Topology/Topology";
import { StoreBlock } from "pages/Sections/GettingStartedWithUniFi/_components/StoreBlock";
import { FullStackNetworkingSoftware } from "pages/Sections/GettingStartedWithUniFi/_components/FullStackNetworkingSoftware";
import { PageSwitcher } from "pages/Sections/GettingStartedWithUniFi/_components/PageSwitcher";
import { InView } from "react-intersection-observer";
import { CompareBlock } from "./CompareBlock";
import { HeroComponent } from "./HeroComponent";

export const HowItWorksPage = ({
  hero,
  topology,
  compareOptions,
  compareTabs,
  activePageId,
}: Readonly<IHowItWorksPageProps>) => {
  const { t } = useTranslation();
  const { showBuyButton } = useMicrositeProductPage();

  return (
    <S.ContentWrapper>
      <StyledContainer
        size="desktop"
        noVerticalMargin
        $isMainSection
        $spacing={{ top: 32, bottom: 32 }}
      >
        <S.StyledTitle>{t(hero.title)}</S.StyledTitle>
        <PageSwitcher isOnlyDeploymentTypes activeTabId={activePageId} />
      </StyledContainer>

      <InView as="div" threshold={0.1} trackVisibility delay={100} initialInView>
        {({ inView, ref }) => (
          <div ref={ref}>
            <HeroComponent hero={hero} isInView={inView} />
          </div>
        )}
      </InView>

      <StyledContainer
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 64, bottom: 32 }}
      >
        <MicrositeHeading
          title={t(topology.title)}
          description={t(topology.description)}
          spacing={{ top: 0, bottom: 32 }}
          isCentered
          isSmallDescription
          shouldApplyMobileSpacings
        />

        <Topology
          config={{
            src: topology.config.src,
            aspectRatio: topology.config.aspectRatio,
          }}
          mobileConfig={{
            src: topology.mobileConfig.src,
            aspectRatio: topology.mobileConfig.aspectRatio,
          }}
        />
      </StyledContainer>

      <StoreBlock />

      <StyledContainer
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 64, bottom: 6 }}
      >
        <MicrositeHeading
          title={t("gettingStartedWithUnifi.explore.title")}
          spacing={{ top: 0, bottom: 12 }}
          isCentered
          isSmallDescription
          shouldApplyMobileSpacings
        />
      </StyledContainer>

      <InView as="div" threshold={0.3} trackVisibility delay={100}>
        {({ inView, ref }) => (
          <div ref={ref}>
            <FullStackNetworkingSoftware isInView={inView} />
          </div>
        )}
      </InView>

      <CompareBlock
        compareTabs={compareTabs}
        compareOptions={compareOptions}
        showBuyButton={showBuyButton}
      />

      <StyledContainer
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 32, bottom: 96 }}
      >
        <PageSwitcher activeTabId={activePageId} />
      </StyledContainer>
    </S.ContentWrapper>
  );
};
